import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from './NavBar';
import './Layout.css';
import { useIdleTimeout } from '../hooks/useIdleTimeout';
import { titleForPath } from '../routeTitles';
import { isStagingHost } from '../env';

function IdleWarningModal({ onStay, onLogout }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999
    }}>
      <div style={{
        background: '#fff', borderRadius: 10, padding: '2rem',
        width: 360, maxWidth: '92vw', textAlign: 'center',
        boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
      }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>⏱️</div>
        <h3 style={{ margin: '0 0 8px', color: 'var(--text-strong)' }}>Still there?</h3>
        <p style={{ color: 'var(--text-strong)', marginBottom: 24, fontSize: 15 }}>
          You've been inactive for 14 minutes. You'll be logged out in <strong>1 minute</strong> unless you continue.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <button
            onClick={onStay}
            style={{
              padding: '10px 24px', background: 'var(--accent-color)', color: '#fff',
              border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 15, fontWeight: 600
            }}
          >
            Stay Logged In
          </button>
          <button
            onClick={onLogout}
            style={{
              padding: '10px 24px', background: 'var(--surface-muted)', color: 'var(--text-strong)',
              border: '1px solid var(--border-color)', borderRadius: 6, cursor: 'pointer', fontSize: 15
            }}
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
}

function Layout({ children }) {
  const [showWarning, setShowWarning] = useState(false);
  const location = useLocation();

  useEffect(() => {
    document.title = titleForPath(location.pathname);
  }, [location.pathname]);

  useIdleTimeout({
    onWarn: () => setShowWarning(true),
    onLogout: () => setShowWarning(false),
  });

  return (
    <>
      {isStagingHost() && (
        <div style={{ background: '#B7791F', color: '#fff', textAlign: 'center', fontSize: 12, fontWeight: 700, padding: '4px 8px', letterSpacing: 0.5 }}>
          STAGING — test data only
        </div>
      )}
      <NavBar />
      <div className="layout-container container">
        {children}
      </div>
      {showWarning && (
        <IdleWarningModal
          onStay={() => setShowWarning(false)}
          onLogout={() => {
            setShowWarning(false);
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/';
          }}
        />
      )}
    </>
  );
}

export default Layout;
